import * as CollapsiblePrimitive from "@radix-ui/react-collapsible";
import { useState } from "react";
import styles from "./Collapsible.module.scss";
import classNames from "classnames";
import { ChevronDown, ChevronRight } from "../Icon/Icon";

function Collapsible({
  className,
  title,
  children,
  defaultValue,
}: {
  className?: string;
  title: string;
  children: React.ReactNode;
  defaultValue?: boolean;
}) {
  const [isOpen, setIsOpen] = useState(!!defaultValue);

  return (
    <CollapsiblePrimitive.Root
      className={classNames(styles.container, className)}
      open={isOpen}
      onOpenChange={setIsOpen}
    >
      <CollapsiblePrimitive.Trigger asChild>
        <button
          className={classNames(styles.header, {
            [styles.isOpen]: isOpen,
          })}
        >
          {title}
          {isOpen ? <ChevronDown /> : <ChevronRight />}
        </button>
      </CollapsiblePrimitive.Trigger>

      <CollapsiblePrimitive.Content>{children}</CollapsiblePrimitive.Content>
    </CollapsiblePrimitive.Root>
  );
}

export default Collapsible;
